import { STRINGS } from "../constants/strings";
import { FREITEXT_MAX } from "../state/formState";
import { Textarea } from "./inputs";

interface Props {
  value: string;
  onInput: (value: string) => void;
}

export function ReviewTextCard({ value, onInput }: Props) {
  return (
    <div class="tl-card">
      <Textarea
        label={STRINGS.freitextLabel}
        value={value}
        placeholder={STRINGS.freitextPlaceholder}
        optional
        maxLength={FREITEXT_MAX}
        hint={STRINGS.freitextThirdPartyHint}
        onInput={onInput}
      />
    </div>
  );
}
